import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _history: string[] = ['/'];
  private _initialized = false;
  constructor(private _router: Router) {}

  get previousUrl(): string {
    return this._history[1];
  }

  public matchesPreviousUrl(...segments: string[]) {
    const prev = this.previousUrl;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];
      const prevMatch = prev.toLowerCase().includes(segment.toLowerCase());
      if (prevMatch) {
        return true;
      }
    }

    return false;
  }

  public async goBack() {
    if (this.previousUrl != null) {
      await this._router.navigateByUrl(this.previousUrl);
    }
  }

  public init() {
    if (this._initialized) {
      return;
    }
    this._router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        map((e) => (e as NavigationEnd).urlAfterRedirects),
        distinctUntilChanged(),
      )
      .subscribe((url) => {
        this._history.unshift(url);
        this._history = this._history.slice(0, 10);
      });

    this._initialized = true;
  }
}
